<div class="videoframe">
    <iframe
            [src]="sanitizer.bypassSecurityTrustResourceUrl(data)"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
    ></iframe>
</div>
